var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3613 17.4442L29.358 22.3463C22.6244 23.918 19.7309 31.8678 23.8789 37.4002L36.8173 54.656C39.1334 57.7657 44.1513 59.5921 47.9245 58.6987L68.8431 53.7658C75.5486 52.1838 78.4318 44.2622 74.3121 38.7401L61.4582 21.5151C59.1524 18.3772 54.1344 16.5508 50.3613 17.4442Z",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.076 42.6502L22.2356 55.8614C20.9325 59.4416 22.2998 64.2811 25.2722 66.64L33.1775 72.9013C34.5433 73.9731 37.1086 74.9068 38.872 74.974L48.9525 75.2589C52.7458 75.3625 56.9039 72.5341 58.207 68.9539L62.968 55.8734",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5628 64.2438L75.7192 47.3293",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.26017f5ad1041e2bb784fc7b629d3a07.svg";
export { ForwardRef as ReactComponent };